import $ from "jquery";
import "popper.js"; // Bootstrap requires this
import "bootstrap";
import "slick-slider";
// import "fslightbox";

// Brought over from original theme:
import "../src/js/includes/hoverintent.min.js";
import "../src/js/required/imagesloaded.js";
import "../src/js/required/modernizr.js";
import "../src/js/required/underscore.js";


// Can import modules as needed
// ex. import 'bootstrap/js/dist/dropdown';
// import "./scss/style.scss"; // This is now being imported in the webpack.config file 

// # ---------------------------------------------------------------
// # Custom Methods...
(function ($) {
	// $(function () {
	// 	console.log("test 2");
	// });

	$('.skip-to-content').on('click', function (e) {
		var $target = $('#main-content');
		if ($target.length) {
			$target.attr('tabindex', '-1').focus();
		}
	});

	var $, accordionToggleStatusLabel, checkGrantSearchInnerWrapperHeight, checkGrantSearchTab, grantSearchTab, grantSearchTabToggle, hideAccessibilityPanel, swapLogoAccessibilityTheme, toggleGrantDesc, toggleMobileGrantFilterDropdown, updateContentSliderCounter;

	grantSearchTab = null;

	grantSearchTabToggle = null;

	hideAccessibilityPanel = function () {
		$('[data-accessibility-toggle]').attr('aria-expanded', 'false');
		$('.accessibility-controls-wrapper').removeClass('active');
		$('.accessibility-controls-dropdown').hide();
		$('.accessibility-controls-close-button').find('span.show-for-sr').first().text('Open Control Panel');
		$('.accessibility-controls-close-button').find('i').first().removeClass('fa-times');
		return $('.accessibility-controls-close-button').find('i').first().addClass('fa-angle-down');
	};

	swapLogoAccessibilityTheme = function (theme) {
		var siteLogoDesktop, siteLogoMobile;
		siteLogoDesktop = $('.site-logo.site-logo-desktop');
		siteLogoMobile = $('.site-logo.site-logo-mobile');
		siteLogoDesktop.attr('src', siteLogoDesktop.data('logo-' + theme));
		siteLogoMobile.attr('src', siteLogoMobile.data('logo-' + theme));
	};

	updateContentSliderCounter = function (e, slick, contentSlider) {
		var i;
		i = parseInt(slick.currentSlide + 1);
		return contentSlider.parents('section.layout-section.content_slider').first().find('.slider-counter').text(' ' + i + ' / ' + slick.slideCount);
	};

	toggleMobileGrantFilterDropdown = function (dropdownTabEl) {
		var el, icon, label;
		el = $(dropdownTabEl);
		label = el.find('.button-label').first();
		icon = el.find('i.fas').first();
		if (label.text() === el.data('button-swap-text')) {
			label.text(el.data('button-swap-text-org'));
		} else {
			label.text(el.data('button-swap-text'));
		}
		if (icon.hasClass(el.data('button-swap-icon'))) {
			icon.removeClass(el.data('button-swap-icon'));
			icon.addClass(el.data('button-swap-icon-org'));
		} else {
			icon.removeClass(el.data('button-swap-icon-org'));
			icon.addClass(el.data('button-swap-icon'));
		}
		el.parent('.grant-search-filter-form').find('.grant-search-filter-form-inner').first().slideToggle('fast');
		$('body').toggleClass('form-overlay-open');
	};

	// Toggle open/closed grant card
	toggleGrantDesc = function (element) {

		const el = $(element);

		// Data attributes
		const textOrg = el.data('swap-text-org');   // "More Details"
		const textSwap = el.data('swap-text');      // "Fewer Details"
		const iconOrg = el.data('swap-icon-org');   // "+"
		const iconSwap = el.data('swap-icon');      // "-"
		const title = el.data('title');      // "-"

		// Elements inside
		let label = el.find('.grant-description-toggle-status-label');
		let icon = el.find('i[aria-hidden="true"]');

		el.toggleClass('open');
		let isOpen = el.hasClass('open');

		if (isOpen) {
			// Switching to "open"
			label.text(textSwap);
			icon.text(iconSwap);
			el.attr('aria-label', textSwap + ' about ' + title);
		} else {
			// Going back to original
			label.text(textOrg);
			icon.text(iconOrg);
			el.attr('aria-label', textOrg + ' about ' + title);
		}

	};


	accordionToggleStatusLabel = function (accordionTitleEl) {
		var el, icon, label;
		el = $(accordionTitleEl);
		label = el.find('.accordion-title-status-label').first();
		icon = el.find('i').first();
		if (label.text() === el.data('swap-text')) {
			label.text(el.data('swap-text-org'));
		} else {
			label.text(el.data('swap-text'));
		}
		if (icon.text() === el.data('swap-icon')) {
			icon.text(el.data('swap-icon-org'));
		} else {
			icon.text(el.data('swap-icon'));
		}
	};

	checkGrantSearchInnerWrapperHeight = function () {
		if (window.innerWidth <= 767) {
			// $('.grant-search-filter-form-inner').height(window.innerHeight - $('#site-masthead').outerHeight() - 60);
			$('.grant-search-filter-form-inner').height('auto');
		}
	};

	// checkGrantSearchTab = function () {
	// 	if (grantSearchTabToggle[0] !== void 0) {
	// 		if (window.innerWidth <= 767) {
	// 			if (window.pageYOffset > grantSearchTabToggle[0].offsetTop) {
	// 				grantSearchTab.show();
	// 			} else {
	// 				grantSearchTab.hide();
	// 			}
	// 		}
	// 	}
	// };

	$(document).ready(function () {
		var currentAccessibilityFontSize, currentAccessibilityTheme;
		checkGrantSearchInnerWrapperHeight();

		currentAccessibilityFontSize = localStorage.getItem('accessibilityFontSize');
		if (currentAccessibilityFontSize !== null) {
			$('html').css('font-size', currentAccessibilityFontSize + 'px');

			// Add selected label if font size is smaller or larger than 16px 
			if (currentAccessibilityFontSize < 16) {
				$('#accessibility-control-button-font-decrease').append('<span class="sr-only">Selected</span>');
			} else {
				$('#accessibility-control-button-font-increase').append('<span class="sr-only">Selected</span>');
			}
		}
		currentAccessibilityTheme = localStorage.getItem('accessibilityTheme');

		// console.log('current theme is: ' + currentAccessibilityTheme);
		// console.log('current font size is: ' + parseInt(currentAccessibilityFontSize));

		if (currentAccessibilityTheme !== null) {
			$('body').removeClass('accessibility-theme-default');
			$('body').addClass('accessibility-theme-' + currentAccessibilityTheme);

			$('.accessibility-control-button .sr-only').remove();
			$('button[data-accessibility-color-theme="' + currentAccessibilityTheme + '"]').append('<span class="sr-only">Selected</span>');

			swapLogoAccessibilityTheme(currentAccessibilityTheme);
		} else {
			$('body').addClass('accessibility-theme-default');
			localStorage.setItem('accessibilityTheme', 'default');
			swapLogoAccessibilityTheme('default');
			$('button[data-accessibility-color-theme="default"]').append('<span class="sr-only">Selected</span>');
		}
		$('#accessibility-control-button-font-decrease').click(function (e) {
			currentAccessibilityFontSize = parseInt($('html').css('font-size'));
			if (currentAccessibilityFontSize >= (12 + 3)) {
				currentAccessibilityFontSize = currentAccessibilityFontSize - 3;
				$('html').css('font-size', currentAccessibilityFontSize + 'px');
				localStorage.setItem('accessibilityFontSize', currentAccessibilityFontSize);
			}

			// Add selected label if font size is smaller than 16px
			if (currentAccessibilityFontSize < 16) {
				$('#accessibility-control-button-font-decrease')
					.attr('aria-label', 'Decrease font size 3px, selected')
					.addClass('selected');
				$('#accessibility-control-button-font-increase')
					.attr('aria-label', 'Increase font size 3px')
					.removeClass('selected');
			}
		});
		$('#accessibility-control-button-font-increase').click(function (e) {
			currentAccessibilityFontSize = parseInt($('html').css('font-size'));
			if (currentAccessibilityFontSize <= (36 - 3)) {
				currentAccessibilityFontSize = currentAccessibilityFontSize + 3;
				$('html').css('font-size', currentAccessibilityFontSize + 'px');
				localStorage.setItem('accessibilityFontSize', currentAccessibilityFontSize);
			}
			// Add selected label if font size is smaller than 16px
			if (currentAccessibilityFontSize > 16) {
				$('#accessibility-control-button-font-increase')
					.attr('aria-label', 'Increase font size 3px, selected')
					.addClass('selected');
				$('#accessibility-control-button-font-decrease')
					.attr('aria-label', 'Decrease font size 3px')
					.removeClass('selected');
			}
		});
		$('.accessibility-control-color-button').click(function (e) {
			var accessibilityTheme;
			accessibilityTheme = $(this).data('accessibility-color-theme');
			$('body').attr('class', function (i, c) {
				return c.replace(/(^|\s)accessibility-theme-\S+/g, '');
			});
			$('body').addClass('accessibility-theme-' + accessibilityTheme);
			swapLogoAccessibilityTheme(accessibilityTheme);
			localStorage.setItem('accessibilityTheme', accessibilityTheme);
			$('.accessibility-control-button .sr-only').remove();
			$('button[data-accessibility-color-theme="' + accessibilityTheme + '"]').append('<span class="sr-only">Selected</span>');
		});
		$(document).click(function (e) {
			if (!$(event.target).closest('nav#header-navigation li.menu-item.menu-item-has-children').length) {
				$('nav#header-navigation li.menu-item.menu-item-has-children ul.sub-menu').hide();
				$('nav#header-navigation li.menu-item.menu-item-has-children > button').attr('aria-expanded', 'false');
			}
			if (!$(event.target).closest('.accessibility-controls-wrapper').length) {
				hideAccessibilityPanel();
			}
		});
		$('[data-accessibility-toggle]').click(function (e) {
			var dropdown, icon, parent;
			parent = $(this).parents('.accessibility-controls-wrapper').first();
			parent.toggleClass('active');
			dropdown = parent.find('.accessibility-controls-dropdown').first();
			dropdown.slideToggle('fast');
			icon = parent.find('.accessibility-controls-toggle-wrapper .accessibility-controls-close-button i').first();
			if (parent.hasClass('active')) {
				$('.accessibility-controls-close-button').attr('aria-expanded', 'true');
				//$('.accessibility-controls-close-button').find('span.show-for-sr').text('Close Control Panel');
			} else {
				$('.accessibility-controls-close-button').attr('aria-expanded', 'false');
				//$('.accessibility-controls-close-button').find('span.show-for-sr').text('Open Control Panel');
			}
			icon.toggleClass('fa-angle-up');
			icon.toggleClass('fa-angle-down');
		});
		// Mobile nav all are expanded 
		$('nav#mobile-navigation li.menu-item.menu-item-has-children > button').each(function () {
			$(this).attr('aria-expanded', 'true');
		});

		$('nav.site-navigation li.menu-item.menu-item-has-children > button').click(function (e) {
			e.preventDefault();
			var $parent = $(this).parent('li.menu-item.menu-item-has-children');

			// If already active, close it and return early
			if ($parent.hasClass('active')) {
				$parent.removeClass('active');
				$(this).attr('aria-expanded', 'false');
				$parent.find('ul.sub-menu').first().slideUp(300);
				return;
			}

			// Close other active menus
			$('nav.site-navigation li.menu-item.menu-item-has-children.active').each(function () {
				$(this).removeClass('active');
				$(this).find('a').first().attr('aria-expanded', 'false');
				$(this).find('ul.sub-menu').first().slideUp(300);
			});

			// Open the clicked menu
			$parent.addClass('active');
			$(this).attr('aria-expanded', 'true');
			$parent.find('ul.sub-menu').first().slideDown(300);
		});

		$('#mobile-nav-toggle-button').click(function (e) {

			const isExpanded = $(this).attr('aria-expanded') === 'true';

			// Toggle aria-expanded
			$(this).attr('aria-expanded', !isExpanded);

			$(this).toggleClass('active');
			$('#mobile-navigation').slideToggle('fast');
			$('body').toggleClass('menu-overlay-open');
		});
		$('section.layout-section.content_slider .content-slides').each(function () {
			var contentSlider;
			contentSlider = $(this);
			contentSlider.on('init', function (e, slick) {
				return updateContentSliderCounter(e, slick, contentSlider);
			});
			contentSlider.slick({
				prevArrow: contentSlider.parents('section.layout-section.content_slider').first().find('.content-slider-prev').first(),
				nextArrow: contentSlider.parents('section.layout-section.content_slider').first().find('.content-slider-next').first()
			});
			contentSlider.on('afterChange', function (e, slick, currentSlide) {
				return updateContentSliderCounter(e, slick, contentSlider);
			});
		});
		$('[data-accordion-item] .accordion-title').click(function (e) {
			var accordionGroup, accordionItem;
			e.preventDefault();
			accordionGroup = $(this).parents('[data-accordion]').first();
			accordionItem = $(this).parents('[data-accordion-item]').first();
			if (accordionItem.hasClass('is-active')) {
				accordionItem.removeClass('is-active');
				accordionToggleStatusLabel($(this));
				accordionItem.children('.accordion-content').slideUp('fast');
				accordionItem.children('.accordion-title').attr('aria-expanded', 'false');
				return;
			}
			accordionGroup.find('.accordion-item').each(function () {
				if ($(this).hasClass('is-active')) {
					accordionToggleStatusLabel($(this).find('.accordion-title').first());
					$(this).removeClass('is-active');
					return $(this).find('.accordion-content').slideUp('fast');
				}
			});
			accordionToggleStatusLabel($(this));
			accordionItem.addClass('is-active');
			accordionItem.find('.accordion-content').slideDown('fast');
			accordionItem.children('.accordion-title').attr('aria-expanded', 'true');
			if (this.hash !== void 0) {
				window.history.pushState($(this).text(), document.title, location.protocol + '//' + location.hostname + location.search + location.pathname + this.hash);
			}
		});
		// Grant card toggle open
		function handleGrantToggle(element) {
			toggleGrantDesc(element);
			return $(element)
				.parent('article.type-grant')
				.find('.grant-hidden-content-wrapper')
				.slideToggle('fast');
		}

		$('.grant-expand-toggle')
			.on('click', function (e) {
				handleGrantToggle(this);
			})
			.on('keydown', function (e) {
				if (e.key === 'Enter' || e.keyCode === 13) {
					e.preventDefault(); // Prevent default behavior like link activation
					handleGrantToggle(this);
				}
			});
		//

		$('.filter-all-option').click(function (e) {
			if (!$(this).is('checked')) {
				$(this).attr('checked', 'checked');
				$('input[name="' + this.name + '"]').not(this).removeAttr('checked');
			}
		});
		$('.filter-option').click(function (e) {
			if ($('input[name="' + this.name + '"]:checked').length > 0) {
				$('input[name="' + this.name + '"].filter-all-option').removeAttr('checked');
			} else {
				$('input[name="' + this.name + '"].filter-all-option').attr('checked', 'checked');
			}
		});
		$('.grant-result-tag').click(function (e) {
			var el;
			el = $(this);
			if (el.data('filter-value') === 'grant_keyword') {
				$('input[name="filter_grant_keyword"]')[0].value = "";
			} else {
				$('input[name="' + el.data('filter-group') + '[]"][value="' + el.data('filter-value') + '"]').removeAttr('checked');
			}
			el.remove();
			$('form.grant-search-filter-form').submit();
		});
		$('.grant-search-filter-dropdown-tab').click(function (e) {
			e.preventDefault();
			toggleMobileGrantFilterDropdown(this);
		});
		$('.mobile-search-filter-dropdown-toggle').click(function (e) {
			e.preventDefault();
			toggleMobileGrantFilterDropdown($('.grant-search-filter-dropdown-tab'));
		});
		$('a[href*="#"]').not('[href="#"]').not('[role="tab"]').click(function (event) {
			var target;
			if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
				target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				if (target.length) {
					event.preventDefault();
					window.history.pushState($(this).text(), document.title, location.protocol + '//' + location.hostname + location.search + location.pathname + this.hash);
					if (target.hasClass('accordion-item')) {
						target.find('.accordion-title').first().click();
					}
					$('html, body').animate({
						scrollTop: target.offset().top - $('#site-masthead').outerHeight() - 75
					}, 75, function () {
						var $target;
						$target = $(target);
						if (!$target.hasClass('accordion-item')) {
							$target.focus();
							if ($target.is(':focus')) {
								return false;
							} else {
								$target.attr('tabindex', '-1');
								$target.focus();
							}
						}
					});
				}
			}
		});
	});

	$(window).load(function () {
		var elem, hash;
		grantSearchTab = $('#grant-search-filter-mobile-tab');
		grantSearchTabToggle = $('#grant-search-filter-mobile-toggle');
		hash = window.location.hash.substr(1);
		if (hash.length > 0 && $('[data-accordion] .accordion-item#' + hash).length > 0) {
			elem = $('[data-accordion] .accordion-item#' + hash + ' > a.accordion-title');
			if (!$('[data-accordion] .accordion-item#' + hash).hasClass('is-active')) {
				elem.click();
			}
		}
		$('span.gfield_required').each(function () {
			this.innerText = "[ required ]";
		});
	});

	$(window).on('hashchange', function () {
		var elem, hash;
		hash = window.location.hash.substr(1);
		if (hash.length > 0 && $('[data-accordion] .accordion-item#' + hash).length > 0) {
			elem = $('[data-accordion] .accordion-item#' + hash + ' > a.accordion-title');
			if (!$('[data-accordion] .accordion-item#' + hash).hasClass('is-active')) {
				elem.click();
			}
		}
	});

	$(window).on('resize', function () {
		checkGrantSearchInnerWrapperHeight();
	});

	// $(window).on('scroll', function () {
	// 	checkGrantSearchTab();
	// });

	$(document).ready(function (e) {
		//  Toggle back to top button visibility
		$(document).scroll(function (e) {
			// If there is a jump link list, and on mobile 
			if ($('.page-jump-link-list-wrapper.scrolled').length && window.innerWidth < 1024) {
				var footer = $('.site-footer'); // Select your footer element
				var footerTop = footer.offset().top;
				var footerHeight = footer.outerHeight();

				// Only trigger fadeIn if at least 100px of footer is visible in the viewport
				if (($(window).scrollTop() - footerTop + footerHeight - 100) > 0) {
					$('.back-to-top-button').fadeIn(200);
					$('.page-jump-link-list-wrapper.scrolled').fadeOut(200);
				} else {
					$('.back-to-top-button').fadeOut(200);
					$('.page-jump-link-list-wrapper.scrolled').fadeIn(200);
				}
			} else {
				// Default
				if ($(this).scrollTop() > 100) {
					$('.back-to-top-button').fadeIn(200);
				} else {
					$('.back-to-top-button').fadeOut(200);
				}
			}
		});
	});
	//  END Toggle back to top button visibility

	$('.back-to-top-button').click(function (e) {
		$('html,body').animate({
			scrollTop: 0
		}, 500);
		$('#site-masthead').attr('tabindex', '-1');
		$('#site-masthead').focus();
		return false;
	});

	// Check for when to reposition jump link menu
	function throttle(fn, wait) {
		let time = Date.now();
		return function () {
			if ((time + wait - Date.now()) < 0) {
				fn();
				time = Date.now();
			}
		};
	}

	const $header = $('.site-header');
	const $target = $('.page-jump-link-list-wrapper.top');
	const $scrolledTarget = $('.page-jump-link-list-wrapper.scrolled');
	const threshold = 5;

	let isIntersecting = false;

	function checkScrollPosition() {
		// Exit early if the target or scrolled target doesn't exist
		if (!$target.length || !$scrolledTarget.length) return;

		const viewportWidth = window.innerWidth;
		const targetBottom = $target.offset().top + $target.outerHeight();

		let nowIntersecting;

		if (viewportWidth >= 1024) {
			// On large screens, switch when bottom of jump link menu passes top of page
			nowIntersecting = targetBottom <= $(window).scrollTop() + threshold;
		} else {
			// On smaller screens, keep the original logic using header bottom
			const headerBottom = $header.offset().top + $header.outerHeight();
			nowIntersecting = targetBottom <= headerBottom - threshold;
		}

		if (nowIntersecting !== isIntersecting) {
			isIntersecting = nowIntersecting;
			$scrolledTarget.toggleClass('d-none', !isIntersecting);
		}
	}

	const throttledScroll = throttle(checkScrollPosition, 100);

	$(window).on('scroll resize', throttledScroll);

	// Trigger once on load
	checkScrollPosition();

	// Open jump link menu on label click
	$('.jump-link-scrolled-label').on('click', function (e) {
		$('.page-jump-link-list-wrapper.scrolled').toggleClass('open');
		var $btn = $('.page-jump-link-list-wrapper.scrolled button.text');
		$btn.attr('aria-expanded', $btn.attr('aria-expanded') === 'true' ? 'false' : 'true');
	});
	$('.page-jump-link-list-wrapper.scrolled a').on('click', function (e) {
		$('.page-jump-link-list-wrapper.scrolled').toggleClass('open');
		var $btn = $('.page-jump-link-list-wrapper.scrolled button.text');
		$btn.attr('aria-expanded', $btn.attr('aria-expanded') === 'true' ? 'false' : 'true');

	});
	// Add open class on focus
	$('.page-jump-link-list-wrapper.scrolled a').on('focus', function (e) {
		$('.page-jump-link-list-wrapper.scrolled').addClass('open');
		$('.page-jump-link-list-wrapper.scrolled button.text').attr('aria-expanded', 'true');
	});
	// And remove when lose focus
	$('.page-jump-link-list-wrapper.scrolled a').on('blur', function (e) {
		// Only remove if no other children are focused
		setTimeout(function () {
			if (!$('.page-jump-link-list-wrapper.scrolled').find(':focus').length) {
				$('.page-jump-link-list-wrapper.scrolled').removeClass('open');
				$('.page-jump-link-list-wrapper.scrolled button.text').attr('aria-expanded', 'false');
			}
		}, 10); // Timeout gives browser time to shift focus
	});

	//

	// Home page collage animation
	document.addEventListener("DOMContentLoaded", () => {
		const items = document.querySelectorAll(".fade-in");

		const observer = new IntersectionObserver((entries, obs) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.classList.add("visible");
					obs.unobserve(entry.target);
				}
			});
		}, {
			threshold: 0.5
		});

		items.forEach(item => {
			observer.observe(item);
		});
	});
	//

	//Calculate and add page-content padding
	// Also position the grant filter menu on mobile 
	function adjustPageContentPadding() {
		if ($(window).width() < 1024) {
			var headerHeight = $('header.site-header').outerHeight();
			var adminBarHeight = $('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0;
			//var totalPadding = headerHeight;
			$('main.page-content').css('padding-top', headerHeight + 'px');

			$('.grant-search-filter-form-column').css('top', headerHeight + 'px');

			// Apply margin to header to avoid being overlapped by admin bar
			if (adminBarHeight > 0) {
				$('header.site-header').css('margin-top', adminBarHeight + 'px');

				$('.grant-search-filter-form-column').css('top', (headerHeight + adminBarHeight) + 'px');

			} else {
				$('header.site-header').css('margin-top', '');
				$('.grant-search-filter-form-column').css('top', headerHeight + 'px');
			}
		} else {
			// Reset padding if screen is wider
			$('main.page-content').css('padding-top', '');
			$('header.site-header').css('margin-top', '');
		}
	}


	$(document).ready(function () {
		// Initial run
		adjustPageContentPadding();

		let resizeTimeout;
		// Re-run on window resize
		$(window).on('resize', function () {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(adjustPageContentPadding, 100);
		});

		// Add aria label to wp page navi pagination
		$('.wp-pagenavi[role="navigation"]').attr('aria-label', 'pagination');
	});

	// Update Menu top level item aria states - always expanded on mobile
	// function updateMenuAriaStates() {

	// 	var windowSize = $(window).width();

	// 	if (windowSize < 1366) {
	// 		$('.menu-item-has-children > a[role="button"]').each(function () {
	// 			// Always open in small view
	// 			$(this).attr('aria-expanded', 'true');
	// 		});
	// 	}
	// }

	// // // Run on load + resize
	// $(window).on('resize', updateMenuAriaStates);

})($);
